import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./MessageEmptyList.scss";
export default class MessageEmptyList extends Component {
  static propTypes = {
    children: PropTypes.object,
  };
  static defaultProps = {
    defaultMessage: <div className="message">Nic k zobrazení</div>,
  };

  render() {
    const { defaultMessage, children, className } = this.props;
    const cls = ["message-empty-list", className];
    return <div className={classNames(cls)}>{children ? children : defaultMessage}</div>;
  }
}
